window.addEventListener("DOMContentLoaded", () => {
  let scrolledDown = false;

  function toggleBodyClass() {
    const targetElement = document.querySelector(".announcement");
    if (!targetElement) return;

    const targetOffset =
      targetElement.getBoundingClientRect().top + window.scrollY;
    const scrollPosition = window.scrollY || document.documentElement.scrollTop;

    if (scrollPosition > targetOffset && !scrolledDown) {
      scrolledDown = true;
      const stickyBarWrapper = document.querySelector(
        ".limoniapps-stick-to-top_page_sticky"
      );
      const height = stickyBarWrapper ? stickyBarWrapper.offsetHeight : 0;
      document.documentElement.style.setProperty("--limo-height", `${height}px`);
      document.body.classList.add("scrolled");
    } else if (scrollPosition <= targetOffset && scrolledDown) {
      document.body.classList.remove("scrolled");
      scrolledDown = false;
    }
  }

  window.addEventListener("scroll", toggleBodyClass);
});
